/**
 * SkeletonBlock — the shimmering placeholder both billing surfaces use.
 *
 * WHY IT MOVED HERE. `/pricing` has had a proper 7-block skeleton in its hire
 * card since the day a subscriber read "hire now" for a beat before the card
 * flipped to their actual plan. `/subscription` — the page an existing customer
 * lands on — had nothing: an empty card reading `loading…` in grey, for as long
 * as the billing read takes. On a cold first visit that is up to ~2.5 s before
 * the request is even ISSUED (the page waits on workspace scope, backstopped by
 * SCOPE_FALLBACK_MS) plus the round trip.
 *
 * A second copy would have drifted from the first, so this is the one.
 *
 * Reduced motion is respected: the shape still holds the space, it just stops
 * shimmering. A placeholder that animates for someone who asked for stillness
 * is worse than no placeholder.
 */

import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const SkeletonBlock = styled.div<{
  $h: string;
  $w?: string;
  $r?: string;
  $mt?: string;
}>`
  height: ${(p) => p.$h};
  width: ${(p) => p.$w ?? '100%'};
  border-radius: ${(p) => p.$r ?? '8px'};
  margin-top: ${(p) => p.$mt ?? '0'};
  background: linear-gradient(
    90deg,
    rgba(198, 167, 94, 0.13) 25%,
    rgba(247, 243, 232, 0.85) 37%,
    rgba(198, 167, 94, 0.13) 63%
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export default SkeletonBlock;
